/**
 * Mock data pre oprávnené osoby (legitimates)
 */

import { countryIds, municipalityIds } from "./officials";

const generateDate = (yearsAgo, monthOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  return date.toISOString();
};

export const legitimates = [
  {
    id: "legit-001",
    name: "Česká televize",
    username: "ct_admin",
    ic: "00027383",
    databox: "8xzb3ry",
    created: generateDate(5),
    email: "info@ceskatelevize.cz",
    phone: "+420261131111",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Kavčí hory",
      orientationNumber: "140/1",
      zip: "14070",
    },
    contactPerson: {
      firstName: "Jana",
      lastName: "Novotná",
      email: "jana.novotna@ceskatelevize.cz",
      phone: "+420261132222",
    },
    active: true,
  },
  {
    id: "legit-002",
    name: "Český rozhlas",
    username: "cro_admin",
    ic: "45245053",
    databox: "pheadxe",
    created: generateDate(4),
    email: "info@rozhlas.cz",
    phone: "+420221551111",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Vinohradská",
      orientationNumber: "12",
      zip: "12099",
    },
    contactPerson: {
      firstName: "Petr",
      lastName: "Svoboda",
      email: "petr.svoboda@rozhlas.cz",
      phone: "+420221552222",
    },
    active: true,
  },
  {
    id: "legit-003",
    name: "Deník N",
    username: "denikn_admin",
    ic: "03689671",
    databox: "m5sdqhk",
    created: generateDate(3),
    email: "redakce@denikn.cz",
    phone: "+420222111111",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Senovážné náměstí",
      orientationNumber: "978/23",
      zip: "11000",
    },
    contactPerson: {
      firstName: "Martin",
      lastName: "Veselovský",
      email: "martin.veselovsky@denikn.cz",
      phone: "+420222111222",
    },
    active: true,
  },
  {
    id: "legit-004",
    name: "Seznam Zprávy",
    username: "seznam_zpravy",
    ic: "26168685",
    databox: "n5nz42e",
    created: generateDate(2),
    email: "zpravy@seznam.cz",
    phone: "+420234651111",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Radlická",
      orientationNumber: "3294/10",
      zip: "15000",
    },
    contactPerson: {
      firstName: "Jiří",
      lastName: "Kubík",
      email: "jiri.kubik@firma.seznam.cz",
      phone: "+420234652222",
    },
    active: true,
  },
  {
    id: "legit-005",
    name: "Hospodářské noviny",
    username: "hn_redakce",
    ic: "49546201",
    databox: "9f5kdr4",
    created: generateDate(6),
    email: "redakce@ihned.cz",
    phone: "+420225061111",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Za Poříčskou bránou",
      orientationNumber: "377/10",
      zip: "18600",
    },
    contactPerson: {
      firstName: "Lenka",
      lastName: "Zlámalová",
      email: "lenka.zlamalova@economia.cz",
      phone: "+420225062222",
    },
    active: true,
  },
  {
    id: "legit-006",
    name: "iROZHLAS.cz",
    username: "irozhlas_admin",
    ic: "45245053",
    databox: "pheadxe",
    created: generateDate(2, 6),
    email: "irozhlas@rozhlas.cz",
    phone: "+420221553333",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Vinohradská",
      orientationNumber: "12",
      zip: "12099",
    },
    contactPerson: {
      firstName: "Jan",
      lastName: "Bumba",
      email: "jan.bumba@rozhlas.cz",
      phone: "+420221554444",
    },
    active: true,
  },
  {
    id: "legit-007",
    name: "Aktuálně.cz",
    username: "aktualne_news",
    ic: "49618814",
    databox: "abc1234",
    created: generateDate(4, 3),
    email: "redakce@aktualne.cz",
    phone: "+420225065555",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Karla Engliše",
      orientationNumber: "519/11",
      zip: "15000",
    },
    contactPerson: {
      firstName: "Ondřej",
      lastName: "Kundra",
      email: "ondrej.kundra@economia.cz",
      phone: "+420225066666",
    },
    active: true,
  },
  {
    id: "legit-008",
    name: "Novinky.cz",
    username: "novinky_redakce",
    ic: "26168685",
    databox: "def5678",
    created: generateDate(3, 8),
    email: "redakce@novinky.cz",
    phone: "+420234657777",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Radlická",
      orientationNumber: "3294/10",
      zip: "15000",
    },
    contactPerson: {
      firstName: "Tomáš",
      lastName: "Syrovátka",
      email: "tomas.syrovatka@seznam.cz",
      phone: "+420234658888",
    },
    active: true,
  },
  {
    id: "legit-009",
    name: "E15.cz",
    username: "e15_ekonomika",
    ic: "61860441",
    databox: "ghi9012",
    created: generateDate(5, 2),
    email: "redakce@e15.cz",
    phone: "+420296339999",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Komunardů",
      orientationNumber: "1584/42",
      zip: "17000",
    },
    contactPerson: {
      firstName: "Dalibor",
      lastName: "Martínek",
      email: "dalibor.martinek@cncenter.cz",
      phone: "+420296331111",
    },
    active: true,
  },
  {
    id: "legit-010",
    name: "Respekt",
    username: "respekt_tydenik",
    ic: "26714957",
    databox: "jkl3456",
    created: generateDate(6, 1),
    email: "redakce@respekt.cz",
    phone: "+420225062345",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Za Poříčskou bránou",
      orientationNumber: "377/10",
      zip: "18600",
    },
    contactPerson: {
      firstName: "Erik",
      lastName: "Tabery",
      email: "erik.tabery@respekt.cz",
      phone: "+420225063456",
    },
    active: true,
  },
  {
    id: "legit-011",
    name: "Lidové noviny",
    username: "ln_redakce",
    ic: "63080851",
    databox: "mno7890",
    created: generateDate(7),
    email: "redakce@lidovky.cz",
    phone: "+420225064567",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Karla Engliše",
      orientationNumber: "519/11",
      zip: "15000",
    },
    contactPerson: {
      firstName: "Vladimír",
      lastName: "Vodák",
      email: "vladimir.vodak@mafra.cz",
      phone: "+420225065678",
    },
    active: true,
  },
  {
    id: "legit-012",
    name: "MF DNES",
    username: "mfdnes_redakce",
    ic: "63080851",
    databox: "pqr1234",
    created: generateDate(8),
    email: "redakce@idnes.cz",
    phone: "+420225066789",
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Karla Engliše",
      orientationNumber: "519/11",
      zip: "15000",
    },
    contactPerson: {
      firstName: "Jaroslav",
      lastName: "Plesl",
      email: "jaroslav.plesl@mafra.cz",
      phone: "+420225067890",
    },
    active: true,
  },
];

export default legitimates;
